<div class="notfound-page">
  <h3
    class="notfound-page-title"
    data-translation-key="error_pages_page_not_found"
    >
    {{ 'error_pages.page_not_found' | translate }}
  </h3>

  @if (!isSeller) {
    <button
      class="btn btn-primary btn-go"
      (click)="NavigateToLandingPage()"
      data-translation-key="error_pages_go_homepage"
      >
      {{ 'error_pages.go_homepage' | translate }}
    </button>
  }
  <!-- routerLink="/buyer/home" -->
  @if (isSeller) {
    <button
      class="btn btn-primary btn-go"
      routerLink="/seller/dashboard"
      data-translation-key="error_pages_go_dashboard"
      >
      {{ 'error_pages.go_dashboard' | translate }}
    </button>
  }
  <img class="img-404" src="../../../../assets/images/404.svg" />
</div>
